<template>
	<v-row no-gutters>
		<v-col cols="12" lg="6" class="pr-lg-2">
			<table width="100%" class="mt-4 show-dialog-table show-dialog-table--form">
				<!-- TODO 適したフォームに変更する -->
				<tbody>
					<ShowDetailRecord :columnName="'見積先'" :value="'西田鉄工(株)'">
						<template v-slot:value
							><v-text-field background-color="white" dense outlined hide-details></v-text-field
						></template>
					</ShowDetailRecord>
					<ShowDetailRecord :columnName="'客先照会番号'" :value="'12345678'">
						<template v-slot:value
							><v-text-field background-color="white" dense outlined hide-details></v-text-field
						></template>
					</ShowDetailRecord>
					<ShowDetailRecord :columnName="'客先照会日付'" :value="'2020/01/01'">
						<template v-slot:value
							><v-text-field background-color="white" dense outlined hide-details></v-text-field
						></template>
					</ShowDetailRecord>
					<ShowDetailRecord :columnName="'納品場所'" :value="'山梨県飽海郡遊佐町東口道上'">
						<template v-slot:value
							><v-text-field background-color="white" dense outlined hide-details></v-text-field
						></template>
					</ShowDetailRecord>
					<ShowDetailRecord :columnName="'納期'" :value="'2023/09/01'">
						<template v-slot:value
							><v-text-field background-color="white" dense outlined hide-details></v-text-field
						></template>
					</ShowDetailRecord>
					<ShowDetailRecord :columnName="'支払い条件'" :value="'従来通り'">
						<template v-slot:value
							><v-text-field background-color="white" dense outlined hide-details></v-text-field
						></template>
					</ShowDetailRecord>
					<ShowDetailRecord :columnName="'見積有効期限'" :value="'2023/06/01'">
						<template v-slot:value
							><v-text-field background-color="white" dense outlined hide-details></v-text-field
						></template>
					</ShowDetailRecord>
					<ShowDetailRecord :columnName="'客先名'" :value="'(株)湊製作所'">
						<template v-slot:value
							><v-text-field background-color="white" dense outlined hide-details></v-text-field
						></template>
					</ShowDetailRecord>
					<ShowDetailRecord :columnName="'納入先名'" :value="'西田鉄工(株)'">
						<template v-slot:value
							><v-text-field background-color="white" dense outlined hide-details></v-text-field
						></template>
					</ShowDetailRecord>
					<ShowDetailRecord :columnName="'工事名'" :value="'-'">
						<template v-slot:value
							><v-text-field background-color="white" dense outlined hide-details></v-text-field
						></template>
					</ShowDetailRecord>
					<ShowDetailRecord :columnName="'品名'" :value="'ゴム伸縮継手'">
						<template v-slot:value
							><v-text-field background-color="white" dense outlined hide-details></v-text-field
						></template>
					</ShowDetailRecord>
					<ShowDetailRecord
						:columnName="'見積条件'"
						:value="'※ 見積仕様条件は、別紙明細書通りとします。'"
					>
						<template v-slot:value
							><v-text-field background-color="white" dense outlined hide-details></v-text-field
						></template>
					</ShowDetailRecord>

					<ShowDetailRecord :columnName="'添付資料'">
						<template v-slot:value>
							<v-btn color="secondary" class="mt-2" @click="$refs.uploadFile.click()">
								<v-icon class="mr-1">mdi-file-document-plus-outline</v-icon>
								添付書類を追加
								<input
									type="file"
									class="d-none"
									ref="uploadFile"
									@change="addFiles($event)"
									multiple
								/>
							</v-btn>

							<div class="file-area mt-2">
								<span v-if="allFiles < 1" class="filename">選択されていません</span>
								<template v-else>
									<v-chip
										class="ma-1 mt-2"
										close
										outlined
										label
										color="primary"
										v-for="file in existingFiles"
										:key="file.id"
										@click:close="deleteFile(i)"
									>
										<v-icon class="mr-1">mdi-paperclip</v-icon>
										{{ file.name }}
									</v-chip>
									<v-chip
										class="ma-1 mt-2"
										close
										outlined
										label
										color="primary"
										@click:close="removeFile(i)"
										v-for="(file, i) in quotation.files"
										:key="file.name"
									>
										<v-icon class="mr-1">mdi-paperclip</v-icon>
										{{ file.name }}
									</v-chip>
								</template>
							</div>

							<!-- <v-row no-gutters class="flex-nowrap">
								<a :href="''" target="_blank"> ファイル.pdf </a>
							</v-row> -->
						</template>
					</ShowDetailRecord>
				</tbody>
			</table>
		</v-col>
		<v-col cols="12" lg="6" class="pl-lg-2">
			<!-- <div v-for="(matter_product, i) in quotation.matter.matter_products" :key="i">
							<h6 class="font-weight-bold text-body-1">製品{{ i + 1 }}</h6>
							<table width="100%" class="mt-4 show-dialog-table">
								<tbody>
									<ShowDetailRecord :columnName="'品名'" :value="''" />
									<ShowDetailRecord :columnName="'寸法'" :value="''" />
									<ShowDetailRecord :columnName="'数量'" :value="''" />
									<ShowDetailRecord :columnName="'単位'" :value="''" />
									<ShowDetailRecord :columnName="'単価'" :value="''" />
									<ShowDetailRecord :columnName="'適応(型式)'" :value="''" />
								</tbody>
							</table>
						</div> -->

			<h6 class="font-weight-bold text-body-1 mt-4">製品1</h6>
			<table width="100%" class="mt-2 show-dialog-table">
				<tbody>
					<ShowDetailRecord :columnName="'品名'" :value="'ゴム伸縮継手'" />
					<ShowDetailRecord :columnName="'寸法'" :value="'1800A × 900L'" />
					<ShowDetailRecord :columnName="'数量'" :value="'3'" />
					<ShowDetailRecord :columnName="'単位'" :value="'基'" />
					<ShowDetailRecord :columnName="'単価'" :value="'1,880,000'" />
					<ShowDetailRecord :columnName="'適応(型式)'" :value="'DMⅡ100M'" />
				</tbody>
			</table>
		</v-col>
	</v-row>
</template>

<script>
import rules from "../../../helper/rules"
import common from "../../../helper/common"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"

export default {
	props: {
		quotation_data: {
			type: Object,
			required: false,
			default: () => {},
		},
		existingFiles: {
			type: Array,
			required: false,
			default: () => [],
		},
	},
	components: {
		ShowDetailRecord,
	},
	data() {
		return {
			rules,
			common,
		}
	},
	methods: {
		removeFile(index) {
			this.quotation.files.splice(index, 1)
		},
		addFiles(e) {
			const files = e.target.files
			Object.entries(files).forEach((file) => {
				this.quotation.files.push(file[1])
			})
		},
		deleteFile(index) {
			// TODO: ファイル削除処理
		},
	},
	computed: {
		quotation: {
			get() {
				return this.quotation_data
			},
			set(newValue) {
				return this.$emit("update:quotation_data", newValue)
			},
		},
		allFiles() {
			return this.quotation.files?.length + this.existingFiles.length
		},
	},
}
</script>
